/**
 * 오브젝트 풀.
 * 생성 시 capacity개를 미리 만들어두고 그 뒤로는 절대 할당하지 않는다.
 * items[0 .. count-1] 이 활성 구간이고, 해제는 꼬리와 swap 해서 O(1).
 *
 * 순회 중 제거할 때는 반드시 인덱스를 되돌려야 한다:
 *   for (let i = 0; i < pool.count; i++) { ... pool.removeAt(i); i--; }
 */
export class Pool<T> {
  readonly items: T[] = [];
  count = 0;

  constructor(capacity: number, factory: (index: number) => T) {
    for (let i = 0; i < capacity; i++) this.items.push(factory(i));
  }

  get capacity(): number {
    return this.items.length;
  }

  get full(): boolean {
    return this.count >= this.items.length;
  }

  /** 여유가 없으면 null */
  spawn(): T | null {
    if (this.count >= this.items.length) return null;
    return this.items[this.count++];
  }

  removeAt(i: number): void {
    const last = --this.count;
    if (i !== last) {
      const tmp = this.items[i];
      this.items[i] = this.items[last];
      this.items[last] = tmp;
    }
  }

  clear(): void {
    this.count = 0;
  }
}
